<template>
  <v-row
    no-gutters
    
    class="sol-row"
    :class="!$vuetify.breakpoint.smAndDown ? 'px-16' : ''"
    style="margin-top: 5px"
  >
    <v-col
      cols="12"
      xl="4"
      lg="4"
      md="6"
      sm="12"
      v-for="(item, index) in this.items"
      :key="index"
    >
      <v-card
        align="start"
        class="sol-card lighten-5 pt-12"
        min-height="35vh"
        flat
      >
        <div>
          <div class="text-merge-box">
            <div
              class="
                bg
                font-weight-thin
                text-h2
                grey--text
                text-lighten-5
              "
            >
              {{ item.stepNo }}
            </div>
            <div class="ovlay-text capt9ion font-weight-medium">
              {{ item.stepText }}
            </div>
          </div>
        </div>

        <v-card-title class="justify-start text-h5 font-weight-medium">{{
          item.title
        }}</v-card-title>
        <v-card-text
          class="font-weight-light subtitle-1 grey--text"
          style="min-height: 90px !important"
          >{{ item.text }}</v-card-text
        >
        <v-divider
          color="#a81e2d"
          width="30px"
          
          :class="!$vuetify.breakpoint.mdAndDown ? 'ml-3' : 'ml-4'"
          style="padding: 1px !important; border: none !important"
        ></v-divider>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped lang="scss">
.text-merge-box {
  margin-left: 18px !important;
  margin-bottom: 18px !important;
  position: relative !important;
}
.ovlay-text {
  padding-top: 20px !important;
  color: #a81e2d !important;
}
.bg {
  opacity: .2!important;
  font-weight: 1000 !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  bottom: 0 !important;
  right: 0 !important;
  z-index: -1 !important;
}


.sol-row {
  min-height: 40vh;
}

.sol-card {
  transition: 0.3s ease;
}
@media only screen and (min-width: 992px) {
.sol-card:hover {
  transform: scale(1.05) !important;
}
}
</style>

<script>
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import DataMixin from "@/components/global/mixins/DataMixin";
export default {
  name: "SolutionsSec",
  data() {
    return {
      items: [
        {
          stepText: "We Teach You",
          stepNo: "01.",
          title: "Consulting & Training",
          text: "Technology investments are only as good as your ability to use and leverage them to do great work. Our trainers equip your team with the skills they need to be successful.",
        },
        {
          stepText: "Customized Solutions",
          stepNo: "02.",
          title: "Network Administration",
          text: "Our engineers make software and hardware work together in harmony to keep your team humming along.",
        },
        {
          stepText: "Specialized & Customized",
          stepNo: "03.",
          title: "Data Analysis & Reporting",
          text: "Use data to drive business decisions with custom reports created based on your organization’s goals.",
        },
      ],
    };
  },
  mounted() {
    gsap.from(".sol-card", {
      scrollTrigger: {
        trigger: ".sol-card",
      },
      opacity: 0,
      y: 150,
      duration: 0.5,
      stagger: 0.3,
    });
  },
};
</script>